<template>
  <div>
    <div class="ios-mask" v-if="showMask">
      <img :src="imgGuide" alt="" />
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import * as utils from '@/utils';
import * as services from '@/services';
import imgGuide from '@/assets/img-ios-guide.png';

export default {
  name: 'Certify',

  components: {},

  data() {
    return {
      showMask: false,
      imgGuide: imgGuide,
    };
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.certifyInit();
  },

  methods: {
    certifyInit() {
      const client = utils.getClientEnv();
      const platform = utils.getPlatform();

      // 支付宝直接调用
      // 微信端Android  跳转url
      // 微信端iOS  提示框去跳转
      // web端iOS   跳转url
      // web端Android   提示微信或者支付宝打开   checkClientEnv已验证

      if (client === 'alipay') {
        // 校验支付宝版本
        if (this.checkAlipayAppVersion()) {
          this.getCertifyInit(true);
        } else {
          this.$router.replace({
            path: '/certify-result',
            query: { error: 'version' },
          });
        }
      } else if (client === 'wechat' && platform === 'ios') {
        this.showMask = true;
      } else {
        this.getCertifyInit(false);
      }
    },

    getCertifyInit(isAlipay) {
      Toast.loading({
        message: '加载中',
        forbidClick: true,
        duration: 0,
      });

      const { businessNo, mobile } = this.$route.query;
      const metaInfo = JSON.stringify(window.getMetaInfo());
      const appSource = utils.getClientEnv();

      services
        .getCertifyInit(businessNo, mobile, metaInfo, appSource)
        .then(res => {
          const { certifyId, certifyUrl, message } = res.data;
          if (certifyId) {
            if (isAlipay) {
              this.toAlipayCertify(certifyId, certifyUrl);
            } else {
              this.toCertifyUrl(certifyId, certifyUrl);
            }
          } else {
            this.$router.replace({
              path: '/certify-result',
              query: { error: 'initError', message },
            });
          }
          Toast.clear();
        });
    },

    alipayJSBridgeReady(callback) {
      if (window.AlipayJSBridge) {
        callback && callback();
      } else {
        document.addEventListener('AlipayJSBridgeReady', callback, false);
      }
    },

    alipayStartAPVerify(options, callback) {
      window.AlipayJSBridge.call(
        'startBizService',
        {
          name: 'open-certify',
          param: JSON.stringify(options),
        },
        callback,
      );
    },

    toAlipayCertify(certifyId, url) {
      this.alipayJSBridgeReady(() => {
        this.alipayStartAPVerify({ certifyId, url }, () => {
          const { businessNo } = this.$route.query;
          const query = { certifyId, businessNo };
          this.$router.replace({ path: '/certify-result', query });
        });
      });
    },

    checkAlipayAppVersion() {
      const normal = ['10', '1', '32'];

      const matchResult = window.navigator.userAgent.match(
        /AliApp\(AP\/([\d\.]+)\)/i,
      );
      const apVersion = matchResult && matchResult[1];

      if (!apVersion) return false;

      const version = apVersion.split('.');

      return (
        version[0] > normal[0] ||
        (version[0] === normal[0] &&
          version.slice(1, 3).join('.') > normal.slice(1, 3).join('.'))
      );
    },

    toCertifyUrl(certifyId, url) {
      if (!url) {
        Toast.fail('系统异常');
        this.$router.back();
      }

      window.location.replace(url);
    },
  },
};
</script>

<style lang="less">
.ios-mask {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  position: relative;
  img {
    width: 70%;
    position: absolute;
    top: 0;
    right: 12px;
  }
}
</style>
